import React from 'react'
import CustomFieldDetail from 'src/app/CustomFieldDetail/CustomFieldDetail'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { customFieldDetailRouteProps } from 'src/navigation/routeProps'

const CustomFieldDetailAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsCustomFieldDetail,
  routeProps: customFieldDetailRouteProps,
  component: <CustomFieldDetail />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default CustomFieldDetailAppRoute
